require('angular-gridster/dist/angular-gridster.css');
const angularGridsterModule  = require('angular-gridster');
const headerModule = require('gw-um-header/headerModule.js');

angular.module('umLanding', [
    angularGridsterModule.name,
    headerModule
])
    .config(function ($stateProvider) {

        $stateProvider
            .state('landing', {
                url: '/landing',
                views: {
                    'header': {
                        templateUrl: '/common/header/appHeader.tpl.html',
                        controller: 'appHeaderController'
                    },
                    'content': {
                        templateUrl: '/landing/landing.tpl.html',
                        controller: 'landingController'
                    }
                }
            });
    })
    .value('landingConstant', {
        event: {
            TASKS_LOADED: 'landing.tasksLoaded',
            ACTIVITIES_LOADED: 'landing.activitiesLoaded',
            OPEN_TASK_DETAIL_DRAWER: 'landing.openTaskDetailDrawer',
            CLOSE_TASK_DETAIL_DRAWER: 'landing.closeTaskDetailDrawer'
        }
    })
    .run(function () {
    });

require('./landingMediator');
require('./landingController');
require('./landing.tpl.html');
require('./repository/loadActivityRepository');
require('./repository/loadTaskRepository');
require('./repository/loadWidgetLayoutTemplateRepository');
require('./termsAndConditions/termsAndConditions.tpl.html');
require('./termsAndConditions/termsAndConditions.less');
require('./termsAndConditions/termsAndConditionsController.js');
require('./widget/uiWidgetGridScrollManager');
require('./widget/externalUrl/externalUrlComponent');
require('./widget/recentActivity/recentActivityComponent.js');
require('./widget/taskGrid/taskGridComponent');
require('./directives/taskDetailsDrawer/taskDetailsDrawerDirective.js');
require('./directives/taskDetailsDrawer/taskDetailsDrawerDirective.tpl.html');

module.exports = 'umLanding';
